import {
  CreateCompanyDocumentRequest,
  UpdateCompanyDocumentRequest,
  checkAddCompanyDocument,
  checkRemoveCompanyDocument,
  checkUpdateCompanyDocument,
} from '@beeboard/common';
import { defineStore } from 'pinia';
import { useCompanyDocumentStore } from './companyDocumentStore';

export const useCompanyDocumentRulesStore = defineStore(
  'companyDocumentRulesStore',
  {
    actions: {
      validateCreateCompanyDocumentRequest(
        payload: CreateCompanyDocumentRequest,
      ) {
        const docTitles = useCompanyDocumentStore().companyDocuments.map(
          (d) => d.title,
        );

        return checkAddCompanyDocument(payload, docTitles);
      },

      validateUpdateCompanyDocumentRequest(
        payload: UpdateCompanyDocumentRequest,
        documentId: string,
      ) {
        const docTitles = useCompanyDocumentStore()
          .companyDocuments.filter((d) => d.id !== documentId)
          .map((d) => d.title);

        return checkUpdateCompanyDocument(payload, docTitles);
      },

      validateRemoveCompanyDocumentRequest(documentId: string) {
        return checkRemoveCompanyDocument(
          useCompanyDocumentStore().companyDocument(documentId),
        );
      },
    },
  },
);
